
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-filter-list',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({
    default: () => {
      return [];
    },
  })
  readonly subCategories: Array<object>;
  @Prop() readonly categoryName: string;
  @Prop({default: null}) readonly categoryId: null | number;

  private filterOpen: boolean = ! this.$mobileDetect.mobile();

  private get totalProductCount(): number {
    return this.$store.getters[`${this.dataSource}/totalItemCount`];
  }

  private get activeFilters(): Array<object> {
    return this.$store.getters[`${this.dataSource}/activeFilters`];
  }

  private get filterList(): Array<object> {
    return [...(this.$store.getters[`${this.dataSource}/filterList`] || []).filter((f) => f['is_visible']), ...(this.$store.getters[`${this.dataSource}/priceFilters`] || [])];
  }

  private determineFilterComponent(filter: object): string {
    if (filter['type'] === 'price') {
      return 'catalog-product-list-price-filter';
    }

    if (filter['renderer'] === 'swatch_visual') {
      return 'catalog-product-list-swatch-filter';
    }

    return 'catalog-product-list-attribute-filter';
  }

  private removeFilters(): void {
    this.$store.dispatch(`${this.dataSource}/fetchCatalog`, {filters: []});
  }
}
